import { PRODUCTS, FOOTER_LINKS } from "@/lib/marketing";

export const SiteFooter = () => (
  <footer className="bg-[#121A14] text-white" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 py-14">
      <div className="grid sm:grid-cols-2 lg:grid-cols-6 gap-6" data-testid="footer-product-strip">
        {PRODUCTS.map((p) => (
          <a key={p.name} href={p.href} data-testid={`footer-product-${p.name.toLowerCase()}`}
             className={`block rounded-sm p-4 border transition-colors duration-200 ${p.current ? "border-[#6D9C55] bg-white/5" : "border-white/10 hover:border-white/30"}`}>
            <p className="font-display font-semibold flex items-center gap-2">
              <img src={p.icon} alt="" width="32" height="32" className="h-8 w-8 shrink-0" data-testid={`footer-icon-${p.name.toLowerCase().replace(/\s+/g, "-")}`} />
              {p.name}
            </p>
            <p className="text-xs text-white/60 mt-1.5 leading-relaxed">{p.desc}</p>
          </a>
        ))}
      </div>
      <ul className="flex flex-wrap gap-x-6 gap-y-2 mt-10 text-sm text-white/70" data-testid="footer-links">
        {FOOTER_LINKS.map((l) => (
          <li key={l.label}><a href={l.href} className="hover:text-white">{l.label}</a></li>
        ))}
      </ul>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row md:items-center justify-between gap-3 text-sm">
        <span className="flex items-center gap-4" data-testid="footer-byline">
          <a href="/" aria-label="EnviSafe home"><img src="/brand/envisafe-lockup-dark.svg" alt="EnviSafe" className="h-8 w-auto" data-testid="brand-lockup-dark" /></a>
          EnviSafe by WorkSafeAgent
        </span>
        <span className="text-white/50" data-testid="footer-company">
          WorkSafeAgent LLC · Abilene, Texas · patent pending
        </span>
      </div>
    </div>
  </footer>
);
